interface IErrorData {
  [key: string]: string | number;
}

interface ILoggerConfig {
  appName: string;
}

let loggerConfig: ILoggerConfig;

function sendError(errorData: IErrorData) {
  try {
    // Don't wait for the response
    fetch('/logging/error', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ appName: loggerConfig.appName, errorData }),
    });
  } catch (e) {
    // handle the error so we don't get stuck in a loop trying to send errors about errors
    console.error(e);
  }
}

const Logger = {
  init(config: ILoggerConfig) {
    loggerConfig = config;

    if (typeof window !== 'undefined') {
      window.onerror = function (
        message,
        source,
        lineNumber,
        columnNumber,
        error,
      ) {
        const errorData: IErrorData = {
          columnNumber,
          lineNumber,
          source,
          url: document.location.href,
        };

        if (error != null) {
          errorData.name = error.name;
          errorData.message = error.message;
          errorData.stack = error.stack;
        } else {
          error.message = typeof message === 'string' ? message : message.type;
        }

        sendError(errorData);
      };
    }
  },

  captureError(error: Error) {
    sendError(
      typeof error === 'string'
        ? { message: error }
        : {
            name: error.name,
            message: error.message,
            stack: error.stack,
          },
    );
  },
};

export default Logger;
